import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';
import { useReactToPrint } from 'react-to-print';
import { Button, Table, Divider } from 'antd';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter } from '../../components/formatters/defFormatter';
import { numberFormatter } from '../../components/formatters/numberFormatter';
import ComponentToPrint from '../print/componentToPrint';
import print from '../print/print';
import { TbDeviceAudioTape } from 'react-icons/tb';


const ViewModal = (props) => {

  const { userData, settingData, warehouseData, auxAccountData, currencyData, defaultCurrency, rateToMainCurrency, rateMainToSecondaryCurrency,
    sessionId, serverApi, devData, localApi, salableData, selectedCompany } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;


  const { showModal, toggleModal, title, journalVoucher, journalVoucherId, refreshTable } = props;
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [showPrintComponent, setShowPrintComponent] = useState(false);
  const [journalVoucherData, setJournalVoucherData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);  

  let api;
  if (devData?.isServer) {
    api = localApi;
  }
  else if (devData?.isOffline) {
    api = localApi;
  }
  else if (devData?.isClient) {
    api = serverApi;
  }

  const mainCurrency = currencyData?.find(option => option.id === settingData.mainCurrencyId) || null;
  const secondaryCurrency = currencyData?.find(option => option.id === settingData.secondaryCurrencyId) || null;


  useEffect(() => {
    if (showModal) {
      if (journalVoucher) {
        if (devData?.isOffline) {
          changeCartForOffline();
        } else {
          setJournalVoucherData(journalVoucher);
        }
      }
      else if (journalVoucherId) {
        fetchData(journalVoucherId)
      }
    }
  }, [showModal]);

  const changeCartForOffline = () => {
    setJournalVoucherData({
      ...journalVoucher, // Use journalVoucher instead of prev
      cart: journalVoucher.cart?.map((item) => {
        const matchedProduct = salableData?.find((product) => product?.id === item?.offlineProductId);
        return {
          ...item,
          product: {
            ...item?.product,
            name: matchedProduct ? matchedProduct?.name : item?.product?.name,
          },
        };
      }),
    });
  };

  const fetchData = async (journalVoucherId) => {
    try {
      setIsLoading(true);

      const data = {
        journalVoucherId,
      }
      const response = await api.get(`/journalVoucher/getbyId`, { params: data });
      if (response) {
        const data = response?.data?.data;
        setJournalVoucherData(data)
      }

      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };






  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (showPrintComponent) {
      const timer = setTimeout(() => {
        handlePrint();
        setShowPrintComponent(false); // Reset state after printing
      }, 100); // Allow time for the component to render
      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [showPrintComponent]);

  const handlePrintStatus = () => {
    setShowPrintComponent(true);
  };

  const handlePrintReceipt = () => {
    const printData = {
      cart: journalVoucherData?.cart,
      invoiceId: journalVoucherData?.id,
      company: journalVoucherData?.company,
      account: journalVoucherData?.account,
      delivery: journalVoucherData?.delivery,
      userName: userData.name,
      vatAmount: vatAmount,
      journalVoucher: journalVoucherData,
      currency: journalVoucherData.transactions[0]?.currency,
      discountPercentage: journalVoucherData?.discountPercentage,
      settingData: settingData,      
    };

    print(printData);
  };




  const isUsingMainCurrency = defaultCurrency?.id == mainCurrency.id ? true : false;

  let cartColumns;

  const costTypes = ['PurchaseInvoice', 'PurchaseReturn', 'PurchaseOrder', 'StockControl', 'StockTransfer', 'OpeningStock'];
  const priceTypes = ['SalesInvoice', 'SalesReturn', 'SalesOrder', 'PosSale', 'PosSaleOrder', 'PosReturn'];
  const expenseTypes = ['ExpenseInvoice'];


  if (costTypes.includes(journalVoucherData?.type)) {

    cartColumns = [
      { title: 'Product', dataIndex: 'product', render: (product) => (product?.name), width: '25%' },
      { title: 'Unit', dataIndex: 'unitName', render: (unitName, record) => (unitName + ' (' + record.unitQuantity + ')') },
      { title: 'Quantity', dataIndex: 'quantity', render: numberFormatter },
      { title: 'FreeQuantity', dataIndex: 'freeQuantity', render: numberFormatter },
      { title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'Cost', dataIndex: 'cost', render: numberFormatter },
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      { title: 'NetCost', dataIndex: 'netCost', render: numberFormatter },
      { title: 'TotalCost', dataIndex: 'totalCost', render: numberFormatter },
      Table.EXPAND_COLUMN,
    ]

  }
  else if (priceTypes.includes(journalVoucherData?.type)) {

    cartColumns = [
      { title: 'Product', dataIndex: 'product', render: (product) => (product?.name), width: '25%' },
      { title: 'Unit', dataIndex: 'unitName', render: (unitName, record) => (unitName + ' (' + record.unitQuantity + ')') },
      { title: 'Price', dataIndex: 'price', render: numberFormatter },
      { title: 'Discount', dataIndex: 'priceDiscountPercentage', render: numberFormatter },
      { title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'NetPrice', dataIndex: 'netPrice', render: numberFormatter },
      { title: 'Quantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'TotalPrice', dataIndex: 'totalPrice', render: numberFormatter },
      Table.EXPAND_COLUMN,
    ]
  }
  else if (expenseTypes.includes(journalVoucherData?.type)) {
    cartColumns = [
      { title: 'Details', dataIndex: 'details', width: '50%' },
      { title: 'NetPrice', dataIndex: 'netPrice', render: numberFormatter },
      { title: 'VatPercentage', dataIndex: 'vatPercentage', render: numberFormatter },
      Table.EXPAND_COLUMN,
    ]
  }

  const paymentColumns = useMemo(() => [
    { title: 'ID', dataIndex: 'id' },
    { title: 'Type', dataIndex: 'type' },
    { title: 'Date', dataIndex: 'date' },
    { title: mainCurrency.code, dataIndex: 'totalCredit', render: numberFormatter },
    secondaryCurrency && { title: secondaryCurrency?.code, dataIndex: 'secondaryTotalCredit', render: numberFormatter },
    { title: 'Status', dataIndex: 'status', render: statusFormatter },
  ].filter(Boolean));


  const JvColumns = useMemo(() => [
    { title: 'Type', dataIndex: 'type' },
    { title: 'Account', dataIndex: 'accountId' },
    { title: 'Name', dataIndex: 'accountName' },
    {
      title: 'Debit',
      dataIndex: 'debit',
      render: numberFormatter,
    },
    {
      title: 'Credit',
      dataIndex: 'credit',
      render: numberFormatter,
    },
    {
      title: 'Rate',
      dataIndex: 'rate',
      render: numberFormatter,
    },
    {
      title: 'Debit ' + mainCurrency?.code,
      dataIndex: 'totalDebit',
      render: numberFormatter,
    },
    {
      title: 'Credit ' + mainCurrency?.code,
      dataIndex: 'totalCredit',
      render: numberFormatter,
    },
    secondaryCurrency && {
      title: 'Debit ' + secondaryCurrency?.code,
      dataIndex: 'secondaryTotalDebit',
      render: numberFormatter,
    },
    secondaryCurrency && {
      title: 'Credit ' + secondaryCurrency?.code,
      dataIndex: 'secondaryTotalCredit',
      render: numberFormatter,
    },
    {
      title: 'warehouse',
      dataIndex: 'warehouseName',
    },
  ].filter(Boolean));

  const totalVatAmount = journalVoucherData?.cart?.reduce((sum, item) => { return sum + parseFloat(item.vatAmount * item.netQuantity || 0); }, 0);


  const vatAmount = isUsingMainCurrency ? totalVatAmount : rateToMainCurrency(defaultCurrency, totalVatAmount);
  const secondaryVatAmount = isUsingMainCurrency ? rateMainToSecondaryCurrency(totalVatAmount) : totalVatAmount;

  const totalPaid = journalVoucherData?.payments?.reduce((sum, item) => {
    return item.status === "Paid" ? sum + parseFloat(item.totalCredit) : sum;
  }, 0);

  const secondaryTotalPaid = journalVoucherData?.payments?.reduce((sum, item) => {
    return item.status === "Paid" ? sum + parseFloat(item.secondaryTotalCredit) : sum;
  }, 0);

  const remaining = journalVoucherData?.totalCredit - totalPaid;
  const secondaryRemaining = journalVoucherData?.secondaryTotalCredit - secondaryTotalPaid;


  const updatedTransactions = journalVoucherData?.transactions?.map(transaction => {

    // Find the account with the matching accountId
    const account = auxAccountData?.find(acc => acc.id === transaction.accountId);
    const warehouse = warehouseData?.find(acc => (acc.id === transaction.warehouseId));

    // If account exists, add the accountName field
    return {
      ...transaction,
      accountName: account ? account.english : '-',
      warehouseName: warehouse ? warehouse.name : '-',
      accountId: account?.parent?.accountId + '.' + account?.accountId,
    };
  });


  const totalDebit = updatedTransactions?.reduce((sum, currentItem) => sum + parseFloat(currentItem.debit), 0);
  const totalCredit = updatedTransactions?.reduce((sum, currentItem) => sum + parseFloat(currentItem.credit), 0);



  const handleSubmit = async () => {

    setLoadingEffect(true);

    const data = {
      userId: userData.id,
      journalVoucher: journalVoucherData,
      sessionId,
      isOffline: devData?.isOffline,
      cashAccountId: userRole?.cashAccountId,
    }

    try {
      let res = await api.post(`journalVoucher/createInvoice`, data);

      if (res.data.status) {
        toast.success(res.data.message);
        if (refreshTable) { refreshTable() };
        toggleModal();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setLoadingEffect(false);
    }
  }




  return (
    <Modal show={showModal}
      backdrop="static"
      size={'xl'}
      keyboard={false}
      onHide={toggleModal}
      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }}

    >
      <Modal.Header style={{ display: 'flex', justifyContent: 'center', background: "#23576a" }} closeButton>
        <Modal.Title style={{ color: "white" }} >{journalVoucherData?.type}</Modal.Title>
      </Modal.Header>
      <Modal.Body >


        <Row>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Invoice ID: {journalVoucherData?.id}
          </Col>

          <Col md={3}>
            CreatedAt: {dateTableFormatter(journalVoucherData?.createdAt)}
          </Col>

        </Row>

        <Row>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Session: {journalVoucherData?.session?.name || journalVoucherData?.sessionId}
          </Col>
          <Col md={3}>
            Created By: {journalVoucherData?.created?.name}
          </Col>
        </Row>


        <Row>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Company: {selectedCompany?.name}
          </Col>

          <Col md={3}>
            Date: {journalVoucherData?.date}
          </Col>
        </Row>


        <Row>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Reg#: {selectedCompany?.registrationNumber}
          </Col>

          <Col md={3}>
            Account: {journalVoucherData?.account?.english}
          </Col>
        </Row>


        <Row>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Branch: {journalVoucherData?.branch?.name}
          </Col>

          <Col md={3}>
            Reg#: {journalVoucherData?.account?.registration}
          </Col>
        </Row>


        <Row>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Warehouse: {journalVoucherData?.warehouse?.name}
          </Col>

          <Col md={3}>
            Phone: {journalVoucherData?.account?.phone}
          </Col>
        </Row>


        <Row className='mb-5'>
          <Col md={1}>
          </Col>
          <Col md={7}>
            Ref#: {journalVoucherData?.refNumber}
          </Col>

          <Col md={3}>
            Address: {journalVoucherData?.account?.address}
          </Col>
        </Row>

        {journalVoucherData?.cart?.length > 0 &&
          <>
            <Row className='mb-3 g-4'>
              <Col>
                <Table
                  columns={cartColumns}
                  dataSource={journalVoucherData?.cart}
                  pagination={false}
                  expandable={{
                    expandedRowRender: (record) => (
                      <p style={{ margin: 0, color: '#119FE2' }}>{record.details}</p>
                    ),
                    rowExpandable: (record) => !!record.details, // Only allow rows with details to be expandable
                  }}
                />
              </Col>
            </Row>


            <Row>
              <Col md={7}>
              </Col>
              <Col md={1}>
                Discount
              </Col>
              <Col md={2}>
                {numberFormatter(journalVoucherData?.discountPercentage)}%
              </Col>
            </Row>


            <Row>
              <Col md={7}>
              </Col>
              <Col md={1}>
                VAT 11%
              </Col>
              <Col md={2}>
                {numberFormatter(vatAmount) + mainCurrency?.symbol}
              </Col>
              {secondaryCurrency &&
                <Col md={1}>
                  {numberFormatter(secondaryVatAmount) + secondaryCurrency?.symbol}
                </Col>
              }
            </Row>
            <Row className='mb-5'>
              <Col md={7}>
              </Col>
              <Col md={1}>
                Total
              </Col>
              <Col md={2}>
                {numberFormatter(journalVoucherData?.totalDebit) + mainCurrency?.symbol}
              </Col>
              {secondaryCurrency &&
                <Col md={1}>
                  {numberFormatter(journalVoucherData?.secondaryTotalDebit) + secondaryCurrency?.symbol}
                </Col>
              }
            </Row>


            <Row className='mb-5'>
              <Col md={7}>
              </Col>
              <Col md={2}>
                Currency :{journalVoucherData?.currency?.code}
              </Col>
              {secondaryCurrency &&
                <Col md={2}>
                  Rate :{numberFormatter(journalVoucherData?.currency?.rate)}
                </Col>
              }
            </Row>


          </>
        }

        {journalVoucherData?.payments?.length > 0 &&
          <>
            <Row className='mb-3'>
              <Col md={1}>
              </Col>
              <Col>
                <Table columns={paymentColumns} dataSource={journalVoucherData?.payments} pagination={false} />
              </Col>
              <Col md={1}>
              </Col>
            </Row>

            <Row>
              <Col md={8}>
              </Col>
              <Col md={2}>
                Paid
              </Col>
              <Col md={2}>
                {numberFormatter(isUsingMainCurrency ? totalPaid : secondaryTotalPaid)}
              </Col>
            </Row>


            <Row className='mb-5'>
              <Col md={8}>
              </Col>
              <Col md={2}>
                Remaining
              </Col>
              <Col md={2}>
                {numberFormatter(isUsingMainCurrency ? remaining : secondaryRemaining)}
              </Col>
            </Row>
          </>
        }

        {!devData.isOffline &&
          <>
            <Row className='mb-5'>
              <Col>
                <Table columns={JvColumns} dataSource={updatedTransactions} pagination={false} />
              </Col>
            </Row>

            <Row className='mb-5'>
              <Col md={9}>
              </Col>
              <Col>
                <p>{numberFormatter(totalDebit)}={numberFormatter(totalCredit)}</p>
              </Col>
            </Row>
          </>
        }



        {showPrintComponent && (
          <div style={{ display: 'none' }}>
            <ComponentToPrint
              ref={componentRef}
              journalVoucher={journalVoucherData}
              vatAmount={vatAmount}
              isUsingMainCurrency={defaultCurrency.id === mainCurrency?.id}
              mainCurrency={mainCurrency}
              secondaryCurrency={secondaryCurrency}
              rateMainToSecondaryCurrency={rateMainToSecondaryCurrency}
              selectedCompany={selectedCompany}
              secondaryVatAmount={secondaryVatAmount}
            />
          </div>

        )}


      </Modal.Body>



      <Modal.Footer>
        <Button type="primary" size="large" onClick={handlePrintStatus}>
          Print
        </Button>
        <Button type="primary" size="large" onClick={handlePrintReceipt}>
          Print Receipt
        </Button>

        {journalVoucherData?.isOrder &&
          <Button type="primary" size="large" style={{ backgroundColor: '#23576a' }}
            loading={loadingEffect} onClick={handleSubmit}>
            Create Invoice
          </Button>
        }
      </Modal.Footer>



    </Modal >
  );
};


export default ViewModal;